import React from 'react';

export const CampaignsPageActions: React.FC = () => {
  return <></>;
};

CampaignsPageActions.displayName = 'CampaignsPageActions';